import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { InfoBox, CloseButton } from './CheckoutClosed.styles';
import { InfoMessage } from '../Messages.types';

import { roomRateAvailabilityStatuses } from '../../constants';

export const CheckoutClosed: FC<InfoMessage> = ({
  currentSelectedDate,
  showMessage,
  setShowMessage,
}) => {
  const { t } = useTranslations();

  return showMessage &&
    currentSelectedDate &&
    currentSelectedDate?.type === roomRateAvailabilityStatuses.CHECK_IN_CLOSED ? (
    <InfoBox>
      {t('room.noCheckinAllowed')}
      <CloseButton onClick={() => setShowMessage(false)}>Close</CloseButton>
    </InfoBox>
  ) : null;
};
